import React from 'react';
import { Input, Select } from 'formik-antd';
import { Divider, Typography } from 'antd';
import FormControl from '~/components/Form/FormControl';
import Box from '~/components/Box';
import Row from '~/components/Row';

export default function OwnershipTab({ t, values, errors, touched, countries }) {
  const { Option } = Select;
  const { Text } = Typography;
  return (
    <Box>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="ownership.name"
          error={(touched.ownership?.name && errors.ownership?.name) || errors.ownership?.name}
          label={t('screens:bids.data.ownershipName')}
          required
        >
          <Input name="ownership.name" autoComplete="off" />
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="ownership.representativeCompany"
          error={
            (touched.ownership?.representativeCompany && errors.ownership?.representativeCompany) ||
            errors.ownership?.representativeCompany
          }
          label={t('screens:bids.data.ownershipRepresentativeCompany')}
        >
          <Input name="ownership.representativeCompany" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="ownership.representativeName"
          error={
            (touched.ownership?.representativeName && errors.ownership?.representativeName) ||
            errors.ownership?.representativeName
          }
          label={t('screens:bids.data.ownershipRepresentativeName')}
        >
          <Input name="ownership.representativeName" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="ownership.representativePhone"
          error={
            (touched.ownership?.representativePhone && errors.ownership?.representativePhone) ||
            errors.ownership?.representativePhone
          }
          label={t('screens:bids.data.ownershipRepresentativePhone')}
        >
          <Input name="ownership.representativePhone" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="ownership.representativeEmail"
          error={
            (touched.ownership?.representativeEmail && errors.ownership?.representativeEmail) ||
            errors.ownership?.representativeEmail
          }
          label={t('screens:bids.data.ownershipRepresentativeEmail')}
        >
          <Input name="ownership.representativeEmail" autoComplete="off" maxLength={27} />
        </FormControl>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Text>{t('screens:bids.data.address')}</Text>
      </Divider>
      <Row>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.ownership?.address?.addressLineOne && errors.ownership?.address?.addressLineOne}
          field="ownership.address.addressLineOne"
          label={t('screens:addresses.data.addressLineOne')}
          required
        >
          <Input name="ownership.address.addressLineOne" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.ownership?.address?.addressLineTwo && errors.ownership?.address?.addressLineTwo}
          field="ownership.address.addressLineTwo"
          label={t('screens:addresses.data.addressLineTwo')}
        >
          <Input name="ownership.address.addressLineTwo" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.ownership?.address?.city && errors.ownership?.address?.city}
          field="ownership.address.city"
          label={t('screens:addresses.data.city')}
          required
        >
          <Input name="ownership.address.city" autoComplete="off" maxLength={16} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.ownership?.address?.state && errors.ownership?.address?.state}
          field="ownership.address.state"
          label={t('screens:addresses.data.state')}
          required
        >
          <Input name="ownership.address.state" autoComplete="off" maxLength={21} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          field="ownership.address.zipCode"
          error={touched.ownership?.address?.zipCode && errors.ownership?.address?.zipCode}
          label={t('screens:addresses.data.zipCode')}
          required
        >
          <Input name="ownership.address.zipCode" autoComplete="off" maxLength={13} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.ownership?.address?.country && errors.ownership?.address?.country}
          field="ownership.address.country"
          label={t('screens:addresses.data.country')}
          required
        >
          <Select name="ownership.address.country" placeholder="Select">
            {countries.map(item => {
              return (
                <Option key={item.name} value={item.name}>
                  {item.description}
                </Option>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          cols={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }}
          field="ownership.address.note"
          error={(touched.note && errors.note) || errors.note}
          label={t('screens:addresses.data.note')}
        >
          <Input name="ownership.address.note" autoComplete="off" maxLength={41} />
        </FormControl>
      </Row>
    </Box>
  );
}
